// Centralized content (concise, mobile-first). 書面中文。

export const WEBINAR = {
  dateLabel: "2026/04/23（四）",
  dateLong: "2026 年 4 月 23 日（四）",
  format: "Zoom 線上",
  durationLabel: "2 小時（含 Q&A）",
  ctaCopy: "立即鎖定我的席位",
};

/**
 * Format an ISO date string ("YYYY-MM-DD") into a Traditional-Chinese display.
 * Returns the fallback value if the input is empty/invalid (e.g. when admin
 * settings haven't loaded yet).
 *
 *   formatWebinarDate("2026-04-23", "short") -> "2026/04/23（四）"
 *   formatWebinarDate("2026-04-23", "long")  -> "2026 年 4 月 23 日（四）"
 */
const WEEKDAY_TC = ["日", "一", "二", "三", "四", "五", "六"];

export const formatWebinarDate = (iso, variant = "short", fallback = "") => {
  if (!iso || typeof iso !== "string") return fallback;
  // Accept "YYYY-MM-DD" or any parseable date; prefer pure parse to avoid TZ shift.
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  let y, mo, d, weekday;
  if (m) {
    y = Number(m[1]);
    mo = Number(m[2]);
    d = Number(m[3]);
    // Compute weekday using UTC to avoid TZ off-by-one.
    weekday = new Date(Date.UTC(y, mo - 1, d)).getUTCDay();
  } else {
    const dt = new Date(iso);
    if (isNaN(dt.getTime())) return fallback;
    y = dt.getFullYear();
    mo = dt.getMonth() + 1;
    d = dt.getDate();
    weekday = dt.getDay();
  }
  const w = WEEKDAY_TC[weekday] ?? "";
  if (variant === "long") {
    return `${y} 年 ${mo} 月 ${d} 日（${w}）`;
  }
  // short
  const pad = (n) => String(n).padStart(2, "0");
  return `${y}/${pad(mo)}/${pad(d)}（${w}）`;
};

export const HOOK = {
  eyebrow: "2026 AI × 短片變現分享會",
  title1: "用 10 條短片 × AI",
  title2: "打造每月 6 位數",
  title3: "個人 IP 變現系統",
  subtitle:
    "專為專家、老闆、教練、顧問及任何想透過 IP 變現的你而設。不談理論，只交付可落地的定位框架與 AI 劇本工具。",
};

export const HERO_BULLETS = [
  "紫海定位框架（一頁紙）",
  "10 條爆款片實例拆解",
  "AI 劇本現場示範",
  "2026 三大陷阱揭示",
];

export const SPEAKER_STATS = [
  { num: "15", unit: "年", label: "自媒體實戰" },
  { num: "3000萬", unit: "HKD", label: "最高單年營收" },
  { num: "10億+", unit: "次", label: "累計操盤流量" },
  { num: "300+", unit: "位", label: "學員親手孵化" },
  { num: "41,000", unit: "位", label: "個人 IP 粉絲" },
  { num: "2000萬+", unit: "次", label: "為學員創造流量" },
];

export const SPEAKER = {
  name: "Jacky Lei",
  title: "個人 IP 孵化流量操盤手",
  bio: "15 年自媒體實戰。操盤 10 億流量，孵化 300+ 學員。從泛流量走到變現流量，將 15 年規則結合 AI，打造專為專家、老闆、教練而設的精準流量系統。",
};

export const CASES = [
  {
    id: "case-tutor",
    industry: "補習導師 → 教育 KOL",
    period: "3 個月",
    kpiNumber: "15,000",
    kpiUnit: "粉絲",
    kpiCaption: "從 0 起步，月影片流量 × 1,600 倍",
    metricLabel: "粉絲成長",
    beforeValue: 0,
    afterValue: 15000,
    beforeLabel: "0",
    afterLabel: "15,000",
    growthLabel: "0 → 15,000",
  },
  {
    id: "case-pet",
    industry: "寵物訓練教練",
    period: "2 個月",
    kpiNumber: "HKD 0",
    kpiUnit: "廣告費",
    kpiCaption: "原每月 HKD 5,000 → 零成本獲客",
    metricLabel: "粉絲成長",
    beforeValue: 5000,
    afterValue: 20000,
    beforeLabel: "5,000",
    afterLabel: "20,000",
    growthLabel: "× 4 倍",
  },
  {
    id: "case-cabin",
    industry: "全職空姐 → 創業者",
    period: "5 個月",
    kpiNumber: "× 5",
    kpiUnit: "倍收入",
    kpiCaption: "從打工族到建立個人事業",
    metricLabel: "粉絲成長",
    beforeValue: 28000,
    afterValue: 42000,
    beforeLabel: "28,000",
    afterLabel: "42,000",
    growthLabel: "+ 50%",
  },
  {
    id: "case-parent",
    industry: "育兒教練",
    period: "2 個月",
    kpiNumber: "10 萬+",
    kpiUnit: "HKD 月營收",
    kpiCaption: "從零變現到月入 6 位數",
    metricLabel: "粉絲成長",
    beforeValue: 600,
    afterValue: 7000,
    beforeLabel: "600",
    afterLabel: "7,000",
    growthLabel: "× 11 倍",
  },
  {
    id: "case-health",
    industry: "大健康從業者",
    period: "1 個月",
    kpiNumber: "100 萬+",
    kpiUnit: "月影片流量",
    kpiCaption: "單月突破百萬曝光",
    metricLabel: "粉絲成長",
    beforeValue: 8000,
    afterValue: 18000,
    beforeLabel: "8,000",
    afterLabel: "18,000",
    growthLabel: "× 2.2 倍",
  },
];

export const PAIN_POINTS = [
  "不知道拍什麼",
  "拍了但沒流量",
  "有流量但不成交",
  "追熱點留不住客群",
  "想做 IP 卻不知從何開始",
  "擔心再走冤枉路",
];

export const TAKEAWAYS = [
  {
    n: "01",
    title: "紫海定位框架",
    desc: "一頁紙找出無競爭的精準賽道。",
  },
  {
    n: "02",
    title: "10 條爆款片實例拆解",
    desc: "公開每條片為何能帶來主動私訊購買。",
  },
  {
    n: "03",
    title: "AI 劇本現場示範",
    desc: "說出你的行業，即場生成 10–20 個爆款主題與劇本。",
    badge: "學員專屬",
  },
  {
    n: "04",
    title: "2026 三大致命陷阱",
    desc: "揭示 80% IP 從業者會踩中的定位錯誤。",
  },
];

export const WHY_2026 = [
  {
    title: "AI 拉大差距，不是消除差距",
    desc: "人人能用 AI，但只有具備定位×結構×轉化系統的人，才能被演算法看見。",
  },
  {
    title: "短片進入精準推薦時代",
    desc: "舊方法只能吸引『不買單的泛粉』。你需要高價值受眾的內容結構。",
  },
  {
    title: "專家經濟黃金期剩 18–24 個月",
    desc: "頂尖專家全部上場後，壁壘形成。現在不動，未來用 10 倍成本追趕。",
  },
];

export const FAQS = [
  {
    q: "沒有拍片經驗，聽得懂嗎？",
    a: "能。分享會重點在定位與內容結構，不涉及攝影與剪輯技術。",
  },
  {
    q: "這會不會是割韭菜課程？",
    a: "分享會完全免費。我們會現場公開學員案例與爆款結構，讓你自行判斷方法是否對你有用。",
  },
  {
    q: "有粉絲但變不到現，適合我嗎？",
    a: "非常適合。『有流量但無成交』的根源大多在定位與內容結構錯位，分享會會為你即場診斷。",
  },
  {
    q: "現場會被 Hard Sell 嗎？",
    a: "不會。主軸是交付可用內容。有進一步合作需求再介紹；即使沒有，你照樣帶走完整資產。",
  },
  {
    q: "我行業較特殊也適用嗎？",
    a: "適用。過往學員橫跨教育、醫療、法律、金融、育兒、大健康等多個行業。",
  },
  {
    q: "老闆不想出鏡也能做嗎？",
    a: "能。分享會會介紹品牌代言人、幕後視角與 AI 虛擬代表三種做法，皆有學員成功案例。",
  },
  {
    q: "名額為什麼有限？",
    a: "為保證現場互動品質與 AI 即場示範的個別回應時間，每場僅開放有限名額。",
  },
  {
    q: "會有錄播嗎？",
    a: "為保護分享會價值與即場案例，不提供公開錄播。建議準時入場。",
  },
];

export const SCROLL_REVEAL = {
  initial: { opacity: 0, y: 10 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-50px" },
  transition: { duration: 0.45, ease: [0.22, 1, 0.36, 1] },
};
